const tipoDePagos = [
    { id: 'GENERALES', text: 'Gastos Generales' },
    { id: 'COBRO_AL_CLIENTE', text: 'Cobro extra al cliente' },
    { id: 'PAGO_OPERADOR', text: 'Pago extra al operador' },
];

export default function getTipoDePagos() {
    return tipoDePagos;
}
